<script>
import common from "@/mixins/common.vue";
import {mapActions} from "vuex";
import {getUUId} from "@/utils/tools";

export default {
  name: "InvoiceDetail",
  props: {
    event: String,
    title:String,
    visible: Boolean,
  },
  data(){
    return {
      item: {
        RelateNumber: getUUId(),
        CustomerEmail: '',
        ClearanceMark: 1, // 1：非經海關出口
        Print: 0, // 不要印
        Donation: 0, // 是否捐贈 0不捐 1捐贈
        CarrierType: 1, // 1：綠界電子發票載具
        InvType: '07', // 一般稅額
        TaxType: 1, // 應稅
        InvoiceRemark: '', // 發票備註
        SalesAmount: 0, // 發票總額
        vat: '1',
        CarrierNum: '',
        LoveCode: '168001',  // OMG關懷社會愛心基金會
        CustomerIdentifier: '', // 統編
        CustomerName: '',
        ItemName: '',
        ItemCount: 1,
        ItemWord: '個',
        ItemPrice: 0,
        ItemTaxType: 1,
        ItemAmount: 0,
      },
      loading: false,
      saveLoading: false,
    }
  },
  mixins:[common],
  created() {
  },
  computed: {

  },
  methods: {
    ...mapActions(['saveInvoiceLog']),
    cancelEvent(){
      this.$emit('cancelEvent');
    },
    async confirmEvent(){
      await this.save();
    },
    async save(){
      try {
        this.saveLoading = true;
        const res = await this.saveInvoiceLog(this.item);

        const result = res.data;
        if (result && result.statusCode === 0){
          this.showMessageDialog('成功',result.message);
          this.$emit('confirmEvent');
        } else {
          this.showMessageDialog('提示',result.message ? result.message :'建立發票紀錄失敗！');
        }
      } catch (e) {
        console.log(`saveInvoiceLog error ` , e);
        this.showMessageDialog('提示','建立發票紀錄失敗！');
      } finally {
        this.saveLoading = false
      }
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'80%'">
    <v-card >
      <v-card-title>開立發票紀錄</v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="item.CustomerEmail"
                           :label="'Email'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="item.ItemName"
                           :label="'發票品項'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="item.SalesAmount"
                           :label="'發票總額'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-select
                :color="Theme.GREEN"
                :items="getDonationType"
                :label="'是否捐贈？'"
                item-text="value" item-value="key"
                v-model="item.Donation"/>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-select
                :color="Theme.GREEN"
                :items="getCarrierType"
                :label="'載具類型'"
                item-text="value" item-value="key"
                v-model="item.CarrierType"/>
          </v-flex>
        </v-layout>
        <v-layout v-if="item.CarrierType === 2 || item.CarrierType === 3">
          <v-flex>
            <v-text-field  v-model="item.CarrierNum"
                           :label="'載具號碼'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="item.CustomerIdentifier"
                           :label="'統編'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="item.CustomerName"
                           :label="'公司名稱'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>

      </v-card-text>
      <v-card-actions>
        <v-btn  :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>
